import axios from 'utils/axios';

/**
 * Validates if the user has access to the application
 * @param {string} token - Access token from Entra ID
 * @returns {Promise<{success: boolean, data: object|null, error: object|null}>}
 */
export async function validateUserAccess(token) {
  try {
    const response = await axios.get('/auth/validate', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return {
      success: response.data.success ?? true,
      data: response.data.data || response.data,
      error: null
    };
  } catch (error) {
    console.error('Error in validateUserAccess:', error);

    if (error.error) {
      const errorData = error.error;

      return {
        success: error.success ?? false,
        data: null,
        error: {
          code: errorData.code,
          type: errorData.type,
          message: errorData.message
        }
      };
    }

    if (error.request) {
      return {
        success: false,
        data: null,
        error: {
          code: 0,
          type: 'NetworkError',
          message: 'Could not connect to the server. Please check your internet connection.'
        }
      };
    }

    // Network or unexpected error
    return {
      success: false,
      data: null,
      error: {
        code: 500,
        type: 'UnexpectedError',
        message: error.message || 'Unexpected error while validating access'
      }
    };
  }
}

/**
 * Updates the last login timestamp for the user
 * @param {string} token - Access token from Entra ID
 * @returns {Promise<{success: boolean, error: object|null}>}
 */
export async function updateLastLogin(token) {
  try {
    const response = await axios.post(
      '/auth/last-login',
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return {
      success: response.data.success ?? true,
      error: null
    };
  } catch (error) {
    console.error('Error updating last-login:', error);

    // Return error for logging purposes
    return {
      success: false,
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        type: error.response?.statusText || 'Error',
        message: error.response?.data?.message || 'Error updating last login date'
      }
    };
  }
}
